module.exports = __webpack_public_path__ + "img/99icon_black.c5baf3e1.svg";